module.exports = "/* You can add global styles to this file, and also import other style files */\nbody{\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  background:rgb(231, 230, 227);\n  font-family: Arial !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles